<template>
  <div class="app-carousel" :class="{ 'app-carousel--centered': isCentered }">
    <div class="app-carousel__buttons-wrapper">
      <div class="app-carousel__button app-carousel__button--prev" :class="prevBtnClass">
        <icon-chevron-left-thin
          v-if="thinIcon"
          class="app-carousel__icon app-carousel__icon--thin app-carousel__icon--prev"
          :color="iconColor"
        />
        <i v-else class="app-carousel__icon app-carousel__icon--prev icon-arrow" />
      </div>
      <div class="app-carousel__button app-carousel__button--next" :class="nextBtnClass">
        <icon-chevron-left-thin
          v-if="thinIcon"
          class="app-carousel__icon app-carousel__icon--thin app-carousel__icon--next"
          :color="iconColor"
        />
        <i v-else class="app-carousel__icon app-carousel__icon--next icon-arrow" />
      </div>
    </div>

    <swiper v-bind="{ ...settings, modules: swiperModules }">
      <swiper-slide
        v-for="(item, n) in items"
        :key="`${item.title}-${n}`"
        class="app-carousel__slider-item"
      >
        <slot :model="item" />
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'

import IconChevronLeftThin from '@/components/common/icons/IconChevronLeftThin.vue'

import { useScreenWidth } from '@/composables/useScreenWidth'

export default {
  components: {
    Swiper,
    SwiperSlide,
    IconChevronLeftThin,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    settings: {
      type: Object,
      required: true,
    },
    centered: {
      type: Boolean,
      default: true,
    },
    thinIcon: {
      type: Boolean,
      default: false,
    },
    iconColor: {
      type: String,
      default: '#b9bfc9',
    },
  },
  setup() {
    const { isDesktop, isTablet, screenWidth } = useScreenWidth()

    return {
      swiperModules: [Navigation],
      isDesktop,
      isTablet,
      screenWidth,
    }
  },
  computed: {
    nextBtnClass() {
      if (this.settings.navigation?.nextEl) {
        return { [this.settings.navigation.nextEl.replace('.', '')]: true }
      } else {
        return 'app-carousel__button--hidden'
      }
    },
    prevBtnClass() {
      if (this.settings.navigation?.prevEl) {
        return { [this.settings.navigation.prevEl.replace('.', '')]: true }
      } else {
        return 'app-carousel__button--hidden'
      }
    },
    currentSlidesPerView() {
      const defaultSlidesPerView =
        typeof this.settings.slidesPerView === 'number' ? this.settings.slidesPerView : 1
      const breakpointsSlidesPerView = this.settings.breakpoints
      const breakpointsAsNumbers = Object.keys(breakpointsSlidesPerView).map((el) => +el)
      let currentActiveBreakpoint

      breakpointsAsNumbers.forEach((breakpoint) => {
        if (this.screenWidth <= breakpoint) {
          const isSmallerBreakpointAlreadyAdded =
            typeof currentActiveBreakpoint === 'number' && currentActiveBreakpoint < breakpoint
          if (isSmallerBreakpointAlreadyAdded) return
          currentActiveBreakpoint = breakpoint
        }
      })
      const isActiveBreakpointFound = typeof currentActiveBreakpoint === 'number'
      return isActiveBreakpointFound
        ? breakpointsSlidesPerView[currentActiveBreakpoint].slidesPerView
        : defaultSlidesPerView
    },
    isCentered() {
      return this.centered && this.items.length < this.currentSlidesPerView
    },
  },
}
</script>
